import React, { useState } from 'react';
// reactstrap components
import {
    FormGroup,
    Input,
    Row,
    Col,
} from "reactstrap";
import BasicModal from '../../../../components/Modals/BasicModal'
import {titleCase} from '../../../../utils/views/pages/Dynamics'

const CredentialInformation = (props) => {
    const credential = props.credential
    const formDisabled = props.formDisabled
    const setCredential = props.setCredential
    const [showModal, setShowModal] = useState(false)
    const [warning, setWarning] = useState("")
    const validations = props.validations

    let validateField = (e) => {

        if (!e.target.value.trim() && e.target.required) {

            setWarning('The field \'' + titleCase(e.target.name) + '\' is required!')
            setShowModal(true)

        } else {
            let key = "user_"+e.target.name
            if (validations[key] && !validations[key].test(e.target.value)) {                
                setWarning('Invalid ' + titleCase(e.target.name))
                setShowModal(true)
            }
        }

    }

    let handleInput = (e) => {
        let key = e.target.name
        let updateCredential = credential 
        
        if(!updateCredential["user"])
            updateCredential["user"] = {}

        updateCredential["user"][key] = e.target.value

        setCredential(updateCredential)        
    }

    return (
        <>
            <h6 className="heading-small text-muted mb-4">
                User information
            </h6>
            <div className="pl-lg-4">
                <Row>
                    <Col lg="6">
                        <FormGroup>
                            <label
                                className="form-control-label"
                                htmlFor="input-name"
                            >
                                Name
                            </label>
                            <Input
                                className="form-control-alternative"
                                defaultValue={credential?.user?.name}
                                id="input-name"
                                name="name"
                                placeholder="User Name"
                                type="text"
                                disabled={formDisabled}
                                onChange={handleInput}
                                required={true}
                                onBlur={validateField}
                            />
                        </FormGroup>
                    </Col>       
                    <Col lg="6">
                        <FormGroup>
                            <label
                                className="form-control-label"
                                htmlFor="input-email"
                            >
                                Email Address
                            </label>
                            <Input
                                className="form-control-alternative"
                                id="input-email"
                                defaultValue={credential?.user?.email}
                                type="email"
                                name="email"
                                placeholder="User Email"
                                disabled={formDisabled}
                                onChange={handleInput}
                                required={true}
                                onBlur={validateField}
                            />
                        </FormGroup>
                    </Col>
                    
                </Row>

            </div>

            <BasicModal
                title="Warning"
                message={warning}
                showModal={showModal}
                setShowModal={setShowModal} />
        </>
    )
}

export default CredentialInformation;